"use strict";

define('rs/error/error.view',['e3-modal'], function (E3Modal) {
  var ErrorSectionView = E3Modal.SectionView.extend({
    className: 'modal-error-view',
    events: {
      'click .btn-show-error-details': 'toggleErrorDetails'
    },
    templates: {
      'error.init.template': 'renderInitFragment',
      'error.message.template': 'renderMessageFragment'
    },
    render: function render() {
      this.$el.html(this.renderInitFragment());
    },
    getMessagesContainer: function getMessagesContainer() {
      return this.$(".error-messages-container");
    },
    addMessage: function addMessage(id, message, details) {
      var first = this._first ? false : this._first = true;
      var errorMessageHtml = this.renderMessageFragment({
        id: id,
        message: message,
        details: details,
        first: !first,
        hideMoreDetails: !!window.production
      });
      this.getMessagesContainer().append(errorMessageHtml);
    },
    toggleErrorDetails: function toggleErrorDetails(ev) {
      var showErrorBtn = $(ev.currentTarget),
        errorDetails = showErrorBtn.next();
      if (showErrorBtn.hasClass('visible')) {
        showErrorBtn.html('Show Error Details');
        showErrorBtn.removeClass('visible');
      } else {
        showErrorBtn.html('Hide Error Details');
        showErrorBtn.addClass('visible');
      }
      errorDetails.fadeToggle('fast');
      return false;
    }
  });
  return ErrorSectionView;
});

